import { Box, Chip, Typography } from "@mui/material";
import CourseLevelCoverage from "../CourseLevelCoverage";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import api from "lib/api/api";

const copy = {
  en: { title: "Upcoming course", body: "No fixed teacher or dates yet. Register your interest and take the placement test.", bodyWithoutPlacement: "No fixed teacher or dates yet. Register your interest and we will contact you when a suitable course is available.", action: "Register interest" },
  de: { title: "Geplanter Kurs", body: "Lehrkraft und Termine stehen noch nicht fest. Hinterlasse dein Interesse und mache den Einstufungstest.", bodyWithoutPlacement: "Lehrkraft und Termine stehen noch nicht fest. Melde dein Interesse an und wir kontaktieren dich, sobald ein passender Kurs verfügbar ist.", action: "Interesse anmelden" },
  ar: { title: "دورة قادمة", body: "لم يتم تحديد المدرّس أو المواعيد بعد. سجّل اهتمامك وأجرِ اختبار تحديد المستوى.", bodyWithoutPlacement: "لم يتم تحديد المدرّس أو المواعيد بعد. سجّل اهتمامك وسنتواصل معك عند توفر دورة مناسبة.", action: "سجّل اهتمامك" },
};

const CourseInterestCard = ({ offering }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith("ar") ? "ar" : i18n.language?.startsWith("de") ? "de" : "en";
  const text = copy[lang];
  const [price, setPrice] = useState(null);
  useEffect(() => {
    let active = true;
    api.get(`/course-interest-offerings/${offering.slug}/price`)
      .then((response) => { if (active) setPrice(response.data); })
      .catch(() => { if (active) setPrice(null); });
    return () => { active = false; };
  }, [offering.slug]);
  const requiresPlacement = offering.level !== "A1" && offering.placementRequired !== false;
  return <Box component={Link} to={`/course-interest/${offering.slug}`} sx={{ display: "block", height: "100%", textDecoration: "none", color: "inherit", bgcolor: "#F1F2F3", border: "2px dashed #9AA0A6", borderRadius: 3, overflow: "hidden", transition: ".2s", "&:hover": { transform: "translateY(-6px)", boxShadow: "0 10px 24px rgba(0,0,0,.12)", borderColor: "#6F757B" } }}>
    <Box component="img" src={`/${String(offering.level).toLowerCase()}-course.png`} onError={(e) => { e.currentTarget.src = "/service-german-language.png"; }} alt={offering.level} sx={{ width: "100%", height: 230, objectFit: "cover", filter: "grayscale(35%)", opacity: 0.82 }} />
    <Box sx={{ p: 2.5, direction: lang === "ar" ? "rtl" : "ltr" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap={1} mb={1.5}><Box><Box display="flex" alignItems="center" gap={1}><Typography variant="h5" fontWeight={900}>{offering.level}</Typography><CourseLevelCoverage level={offering.level} compact /></Box></Box><Chip label={text.title} sx={{ bgcolor: "#D7DADD", color: "#343A40", fontWeight: 800 }} /></Box>
      <Typography color="text.secondary" sx={{ minHeight: 72 }}>{requiresPlacement ? text.body : text.bodyWithoutPlacement}</Typography>
      {price?.amount != null && price?.currency && (
        <Typography fontWeight={900} sx={{ mt: 1.5, fontSize: "1.25rem", color: "#111" }}>
          {price.amount} {price.currency}
        </Typography>
      )}
      <Typography fontWeight={900} sx={{ mt: 2, color: "#4F555B" }}>{text.action} →</Typography>
    </Box>
  </Box>;
};

export default CourseInterestCard;
